<template>
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.25 7.5C13.25 7.91421 12.9142 8.25 12.5 8.25C12.0858 8.25 11.75 7.91421 11.75 7.5C11.75 7.08579 12.0858 6.75 12.5 6.75C12.9142 6.75 13.25 7.08579 13.25 7.5Z" fill="#28303F"/>
    <path d="M7.25 7.5C7.25 7.91421 6.91421 8.25 6.5 8.25C6.08579 8.25 5.75 7.91421 5.75 7.5C5.75 7.08579 6.08579 6.75 6.5 6.75C6.91421 6.75 7.25 7.08579 7.25 7.5Z" fill="#28303F"/>
    <path d="M11.75 12C11.75 12 10.9062 11.25 9.5 11.25C8.09375 11.25 7.25 12 7.25 12M13.25 7.5C13.25 7.91421 12.9142 8.25 12.5 8.25C12.0858 8.25 11.75 7.91421 11.75 7.5C11.75 7.08579 12.0858 6.75 12.5 6.75C12.9142 6.75 13.25 7.08579 13.25 7.5ZM7.25 7.5C7.25 7.91421 6.91421 8.25 6.5 8.25C6.08579 8.25 5.75 7.91421 5.75 7.5C5.75 7.08579 6.08579 6.75 6.5 6.75C6.91421 6.75 7.25 7.08579 7.25 7.5ZM17 9C17 13.1421 13.6421 16.5 9.5 16.5C5.35786 16.5 2 13.1421 2 9C2 4.85786 5.35786 1.5 9.5 1.5C13.6421 1.5 17 4.85786 17 9Z" stroke="#FF3B30" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71767D',
    },
    size: {
      type: Number,
      default: 17,
    },
  },
};
</script>